<template>
	<div class="My-Address">
		<div class="na-nav">
			<van-nav-bar
			  title="地址管理"
			  left-text="返回"
			  left-arrow
			  :fixed="true"
			  @click-left="back"
			/>
		</div>
		
		<div class="Empty">
			<van-empty description="你的地址空空如也" v-if="list.length <= 0" :image="carimgurls" >
			</van-empty>
		</div>
		
		<div class="body-content">
			<van-address-list
			  v-model="chosenAddressId"
			  :list="list"
			  default-tag-text="默认"
			  @add="newAddress"
			  @edit="editAddress"
			/>
		</div>
	</div>
</template>
	
<script>
	import '../assets/less/myaddress.less';
	export default{
		data(){
			return{
				// 选择地址的id
				chosenAddressId: '',
				
				carimgurls: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1598452249276&di=e957c4d2634a1ba31354ca96d7f3af03&imgtype=0&src=http%3A%2F%2Fbpic.588ku.com%2Felement_origin_min_pic%2F01%2F38%2F92%2F03573c9ea4377a3.jpg',
				
				//地址列表数据
				list: []
			}
		},
		
		created() {
			//查询收货地址
			this.getReceiveAddress();
		},
		
		methods:{
			
			//返回上一级
			back(){
				this.$router.go(-1);
			},
			
			//查询收货地址
			getReceiveAddress(){
				
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'GET',
					url: '/findAddress',
					params:{
						appkey: this.appkey,
						tokenString
					}
				}).then(result =>{
					this.$toast.clear();
					if (result.data.code == 20000) {
						result.data.result.map(v =>{
							let address = v.province + v.city + v.county + v.addressDetail;
							this.list.push({
								id: v.aid,
								name: v.name,
								tel: v.tel,
								address,
								isDefault: Boolean(v.isDefault)
							})
						})
					} 
				}).catch(err =>{
					this.$toast.clear();
				})
			},	
			
			//新增地址
			newAddress(){
				this.$router.push({name: 'NewAddress'});
			},
			
			//编辑地址
			editAddress(item){
			 this.$router.push({name: 'NewAddress', query: {aid: item.id}});
			}
			
		}
	}
</script>

<style>
</style>
